module.exports = __webpack_public_path__ + "img/Spotify_logo_full_green.11dc437a.png";